"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncConsumeIterator = asyncConsumeIterator;

async function asyncConsumeIterator(iterator) {
  let item;

  while (!(item = await iterator.next()).done) {}

  return item;
}